export default __webpack_public_path__ + "static/media/gbenga.500cfa7c.jpg";